export enum Origin {

  // Working title - wip.ge / Development / Testing
  ACCOUNTING = 'ACCOUNTING',
  // einfach.plus
  EINFACHPLUS = 'EINFACHPLUS',
  // runic.cloud
  RUNICCLOUD = 'RUNICCLOUD',
  // runic.ge
  RUNICGE = 'RUNICGE',
}
